import { render, staticRenderFns } from "./FeedCreate.vue?vue&type=template&id=24ae0b63&"
import script from "./FeedCreate.vue?vue&type=script&lang=ts&"
export * from "./FeedCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports